import {Link} from "react-router-dom";
import {useAuthStore} from "../../store/user-store";

export default function ProductItem({item}){
const authStore=useAuthStore()
    console.log(item)
    return (
       /* <div className={'col-md-3 col-6 my-2'}>
            <Link to={item.is_available?`/products/${item.id}`:''} style={{textDecoration:'none'}} >
           <div className={'d-flex flex-column product-item  justify-content-start' } style={{filter:!item.is_available?"grayscale(100)":"grayscale(0)"}}>
              <div className={'container-img'}>
                  <div className="background" style={{backgroundImage:`url(${item.img})`}}></div>
                  <img  className={'product-img'} loading={'lazy'} src={item.img} alt={item.name}/>
              </div>
               <p className={'text-white'}>{item.name}</p>
               <div className={'d-flex flex-column justify-content-around align-items-start'} style={{gap:'4px'}}>
                   <span className={'text-white p-0 m-0'}> {authStore.formatCurrency(item.price)} {authStore.icon==='syr'?'ل.س':''} </span>
                   <span className={'text-white p-0 m-0 '}> {authStore.formatCurrency(item.syr_price,'SYP')} ل.س </span>
                   {/!*<Link to={`/products/${item.id}`} className={`btn btn-sm orange-btn py-1 px-3 w-100`}>شراء</Link>*!/}
                  {/!* {!item.is_available ? <Link  className={`btn btn-sm text-white bg-secondary py-1 px-3 w-100`}>غير متوفر</Link> :  <Link to={`/products/${item.id}`} className={`btn btn-sm orange-btn py-1 px-3 w-100`}>شراء</Link>}*!/}
               </div>
           </div>
            </Link>
        </div>*/
        <div className={'col-md-3 col-4 my-1'}>
            <Link to={item.is_available? `/products/${item.id}`:''} className={'text-decoration-none'}>
                <div className={'text-center position-relative'}>
                    {item.is_available?<span className={'position-absolute  text-white price'}>{authStore.formatCurrency(item.price,'SYP')} </span> : <span className={'position-absolute  text-white price '}>غير متوفر</span>}

                    <img className={`img-category rounded ${item.is_available? '':'gray'}`} src={item.img} alt=""/>
                </div>
                <p className={'category-title'}>{item.name}</p>
            </Link>
        </div>
    )
}